






















import { VTooltip } from "v-tooltip";

export default {
  name: "BaseTooltipIcon",
  directives: {
    tooltip: VTooltip,
  },
  data: function () {
    return {
      message: "",
    };
  },
  props: {
    widthType: {
      type: String,
      default: "extra-small",
    },
  },
  mounted() {
    this.message = this.$refs.fakeElement.innerHTML;
  },
};
